import { Box, Icon, Image, Theme, Typography } from "@outschool/backpack";
import * as icons from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { Space } from "@outschool/ui-legacy-component-library";
import React from "react";

import learnerCommunityGalleryPreview from "../../images/HowGroupsWork/learnerCommunityGalleryPreview.png";

export default function HowGroupsWork() {
  const { t } = useTranslation(
    "ui-components-website\\ClassDetailsPage\\HowGroupsWork"
  );

  const learnerCommunityGalleryPreviewSrc =
    typeof learnerCommunityGalleryPreview === "string"
      ? learnerCommunityGalleryPreview
      : learnerCommunityGalleryPreview.src;
  return (
    <Box sx={{ marginY: "1em" }}>
      <Typography
        variant="h3"
        sx={{
          textAlign: "center",
          marginBottom: "1em",
        }}
      >
        {t`How does a “Chat Group” work?`}
      </Typography>
      <Box
        flex
        sx={(theme: Theme) => ({
          justifyContent: "space-around",
          flexWrap: "wrap",
          paddingX: "1em",
          [theme.breakpoints.up("md")]: {
            paddingX: 0,
          },
        })}
      >
        <Box
          flex
          sx={{
            flexDirection: "column",
            paddingRight: "0.5em",
            justifyContent: "center",
          }}
        >
          <GroupsDescriptionLine
            color="redhot500"
            icon={icons.fasClock}
            title={t`Access anytime`}
            text={t`Access to an online community, anytime — Share and create with like-minded peers from any device`}
          />
          <Space y="xlarge" />
          <GroupsDescriptionLine
            color="waterslide500"
            icon={icons.faShieldCheck}
            title={t`Verified learners`}
            text={t`A space for verified learners — All participants are verified by Outschool via video before joining`}
          />
          <Space y="xlarge" />
          <GroupsDescriptionLine
            color="bubblegum500"
            icon={icons.fasChalkboardTeacher}
            title={t`Educator-led`}
            text={t`Educator-led activities, events, and discussions — Outschool educator moderates content and facilitates engaging activities`}
          />
        </Box>
        <Image
          src={learnerCommunityGalleryPreviewSrc}
          alt={t`An example group from Learner Community`}
          width={460}
          height={425}
        />
      </Box>
    </Box>
  );
}

function GroupsDescriptionLine({
  icon,
  title,
  text,
  color,
}: {
  color: string;
  icon: icons.IconDefinition;
  title: string;
  text: string;
}) {
  return (
    <Box>
      <Typography
        variant="h6"
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: color,
            borderRadius: "50%",
            paddingLeft: "5px",
            width: "18px",
            height: "18px",
            marginRight: "0.25em",
            position: "relative",
          }}
        >
          <Icon
            icon={icon}
            sx={{
              position: "absolute",
              top: "50%",
              right: "50%",
              transform: "translate(50%,-50%)",
            }}
          />
        </Box>
        {title}
      </Typography>
      <Box>{text}</Box>
    </Box>
  );
}
